module.exports = __webpack_public_path__ + "static/media/sistema-minha-frota-plano-stater.c0369c68.png";